// extracted by mini-css-extract-plugin
export default {"form-footer":"CheckoutFooter_form-footer__RaedF"};